/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourSaveInput = {
    id: string;
    title?: string | null;
    description?: string | null;
    videoURL?: string | null;
    listingLink?: string | null;
    frameURLs?: Array<string> | null;
};
export type UploadTourDetailsMutationVariables = {
    input: TourSaveInput;
};
export type UploadTourDetailsMutationResponse = {
    readonly tourSave: {
        readonly tour: {
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly videoURL: string;
            readonly listingLink: string;
        };
    };
};
export type UploadTourDetailsMutation = {
    readonly response: UploadTourDetailsMutationResponse;
    readonly variables: UploadTourDetailsMutationVariables;
};



/*
mutation UploadTourDetailsMutation(
  $input: TourSaveInput!
) {
  tourSave(input: $input) {
    tour {
      id
      title
      description
      videoURL
      listingLink
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TourSavePayload",
    "kind": "LinkedField",
    "name": "tourSave",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "listingLink",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadTourDetailsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadTourDetailsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8902c57adcd688d25fd9d161370c2cd",
    "id": null,
    "metadata": {},
    "name": "UploadTourDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation UploadTourDetailsMutation(\n  $input: TourSaveInput!\n) {\n  tourSave(input: $input) {\n    tour {\n      id\n      title\n      description\n      videoURL\n      listingLink\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ed38d4a646235e98398ac807d22e08a7';
export default node;
